import axios from 'axios'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

export default function DashNavbar() {

  const auth = useSelector(state => state.auth)
  const {user} = auth

  const handleLogout =async () => {
    try {
      await axios.get('/user/logout')
      localStorage.removeItem('firstLogin')
      window.location.href = '/'
    } catch (err) {
      window.location.href = '/'
    }
  }
  
  return (

    <div className='w-[100%] p-2 flex items-center justify-between text-amber-100 font-englishTitle'>
              <div className='flex items-center gap-5 m-2 font-bold'>
                <img src="/niad.png" alt="logo" className='w-[40px] h-[40px]' />
                <span>Admin Dashboard</span>
              </div>
              <div className='flex items-center m-2 gap-9'>
                {/* <img src="https://images.pexels.com/photos/1102257/pexels-photo-1102257.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="userImage" className='w-[20px] h-[20px] rounded-md object-cover' /> */}
                <span>{user.name}</span>
                <Link className='m-auto text-center' onClick={handleLogout}>Logout</Link>
              </div>
    </div>







    // <div className='w-[100%] p-2 flex items-center justify-between text-amber-100'>
    //     {
    //       users.map(user=>(
    //         <>
    //           <div className='flex items-center gap-5 m-2 font-bold'>
    //             <img src="logo.png" alt="logo" className='w-[20px]' />
    //             <span>Admin Dashboard</span>
    //           </div>
    //           <div className='flex items-center gap-5 m-2'>
    //             <img src="https://images.pexels.com/photos/1102257/pexels-photo-1102257.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="userImage" className='w-[20px] h-[20px] rounded-md object-cover' />
    //             <span>{user.name}</span>
    //           </div>
    //         </>
    //       ))
    //     }
    // </div>
  )
}
